import React from 'react';
import { Navigate } from 'react-router-dom';

export const TabNavigator: React.FC = () => {
  // Redirect ke /Task jika ada yang masih mengakses route ini (misal dari URL WebView lama)
  return <Navigate to="/Task" replace />;
};
